<template>
  <ion-page>
    <ion-content>
      <LargeNavbar
        @backButton="backButton"
        show-back-button
        :title="t('profile.myAccountTitle')"
        :show-actions="false"
      />
      <div class="d-flex w-100 justify-space-center">
        <div class="content w-100 ion-padding">
          <ion-label color="body">{{ t('profile.myAccountDescription') }}</ion-label>
          <ion-row>
            <ion-col size="12">
              <h4 class="h4 text-align-left mt-16 text-color-placeholder">
                {{ t('profile.email.title') }}
              </h4>
              <ion-label>{{ user?.email }}</ion-label>
              <div class="mt-16">
                <ion-button
                  id="open-modal-email"
                  class="text-weight-bold"
                  size="small"
                  fill="outline"
                >
                  <ion-icon :icon="pencilSharp"></ion-icon>
                  {{ t('actions.changeEmail') }}
                </ion-button>
              </div>
            </ion-col>
            <ion-col size="12">
              <h4 class="h4 text-align-left mt-16 text-color-placeholder">
                {{ t('profile.password.title') }}
              </h4>
              <ion-label>**********</ion-label>
              <div class="mt-16">
                <ion-button
                  id="open-modal-password"
                  class="text-weight-bold"
                  size="small"
                  fill="outline"
                >
                  <ion-icon :icon="pencilSharp"></ion-icon>
                  {{ t('actions.changePassword') }}
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-content>
    <ion-modal
      ref="emailModal"
      trigger="open-modal-email"
      :initial-breakpoint="0.4"
      :breakpoints="[0, 0.4]"
      @click="$event.preventDefault()"
    >
      <ion-content>
        <ChangeEmailStepper @close="closeEmailModal" />
      </ion-content>
    </ion-modal>
    <ion-modal
      ref="passwordModal"
      trigger="open-modal-password"
      :initial-breakpoint="0.7"
      :breakpoints="[0, 0.7]"
    >
      <ion-content>
        <ChangePasswordStepper @close="closePasswordModal" />
      </ion-content>
    </ion-modal>
    <ion-modal
      id="recoveryPasswordModal"
      :is-open="toggleRecoveryPassword"
      :initial-breakpoint="0.4"
      :breakpoints="[0, 0.4]"
      @ion-modal-will-close="toggleRecoveryPassword = false"
    >
      <ion-content>
        <RecoveryPasswordStepper />
      </ion-content>
    </ion-modal>
  </ion-page>
</template>
<script setup lang="ts">
  import {
    IonContent,
    IonPage,
    IonIcon,
    IonModal,
    IonRow,
    IonCol,
    IonButton,
    IonLabel,
  } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import { useI18n } from 'vue-i18n';
  import router from '@/router';
  import { useAuth } from '@/composables/useAuth';
  import { pencilSharp } from 'ionicons/icons';
  import ChangePasswordStepper from '@/components/profile/change-password/ChangePasswordStepper.vue';
  import { useProfile } from '@/composables/useProfile';
  import ChangeEmailStepper from '@/components/profile/change-email/ChangeEmailStepper.vue';
  import RecoveryPasswordStepper from '@/components/profile/recovery-password/RecoveryPasswordStepper.vue';
  import { onMounted, ref } from 'vue';

  const { t } = useI18n();
  const { user } = useAuth();
  const { toggleRecoveryPassword } = useProfile();

  const emailModal = ref();
  const passwordModal = ref();
  const closePasswordModal = () => passwordModal.value.$el.dismiss(null, 'cancel');
  const closeEmailModal = () => emailModal.value.$el.dismiss(null, 'cancel');

  const backButton = () => {
    router.back();
  };

  const initialConfig = async () => {
    toggleRecoveryPassword.value = false;
  };

  onMounted(() => {
    initialConfig();
  });
</script>
<style scoped lang="scss">
  ion-button {
    height: 36px;
  }

  ion-modal {
    --border-radius: 25px;
    --background: var(--ion-color-body);
  }

  ion-content {
    --border-radius: 25px;
    --background: white;
  }
</style>
